import React from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Box } from "@mui/material";
import useStyles from "./calendar-toolbar.style";
import CalendarToday from "@iconify/icons-mdi/calendar-today";
import ChevronLeft from "@iconify/icons-mdi/chevron-left";
import ChevronRight from "@iconify/icons-mdi/chevron-right";
import ViewModuleOutline from "@iconify/icons-mdi/view-module-outline";
import ViewStreamOutline from "@iconify/icons-mdi/view-stream-outline";
import { InlineIcon } from "@iconify/react";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

export const MyTimesheetCalendarToolbar: React.FC<{
  view: "month" | "week" | "day";
  onView: (_view: "month" | "week" | "day") => void;
  onNavigate: (_action: "PREV" | "NEXT" | "TODAY") => void;
  date: Date;
  monthFiltering?: boolean;
}> = ({ view, onView, onNavigate, date, monthFiltering }) => {
  const { i18n } = useTranslation();
  const isMobile = useOcIsMobile();

  let title = moment(date).locale(i18n.language).format("YYYY. MMMM");
  const iconSize = 30;

  if (view === "week") {
    let start = moment(date)
      .locale(i18n.language)
      .startOf("week")
      .format("YYYY. MMMM D.");
    let end = moment(date)
      .locale(i18n.language)
      .endOf("week")
      .format("YYYY. MMMM D");
    if (i18n.language !== "hu") {
      start = moment(date)
        .locale(i18n.language)
        .startOf("week")
        .format("DD/MM/YYYY");
      end = moment(date)
        .locale(i18n.language)
        .endOf("week")
        .format("DD/MM/YYYY");
    }
    title = `${start} - ${end}.`;
  }

  const classes = useStyles({ monthFiltering, isMobile });

  return (
    <div className={classes.toolbarMainContainer}>
      <div className={classes.centerContainer}>
        <InlineIcon
          icon={ChevronLeft}
          width={iconSize}
          height={iconSize}
          className={classes.leftChevron}
          onClick={() => onNavigate("PREV")}
        />
        <span className={classes.title}>{title}</span>
        <InlineIcon
          icon={ChevronRight}
          width={iconSize}
          height={iconSize}
          className={classes.rightChevron}
          onClick={() => onNavigate("NEXT")}
        />
      </div>

      {isMobile && <Box height="16px" />}

      <div
        style={{
          paddingTop: 2,
        }}
      >
        <InlineIcon
          icon={CalendarToday}
          width={iconSize}
          height={iconSize}
          onClick={() => onNavigate("TODAY")}
          className={view !== "day" ? classes.icon : classes.iconDisabled}
        />
        <div style={{ display: "inline-block", width: 16 }}></div>
        <div style={{ display: "inline-block", width: 24, height: 24 }}></div>
        <div style={{ display: "inline-block", width: 16 }}></div>
        <InlineIcon
          icon={ViewModuleOutline}
          width={iconSize}
          height={iconSize}
          onClick={() => onView("month")}
          className={view !== "month" ? classes.icon : classes.iconDisabled}
        />
        <div style={{ display: "inline-block", width: 16 }}></div>
        <InlineIcon
          icon={ViewStreamOutline}
          width={iconSize}
          height={iconSize}
          onClick={() => onView("week")}
          className={view !== "week" ? classes.icon : classes.iconDisabled}
        />
      </div>
    </div>
  );
};

export default MyTimesheetCalendarToolbar;
